const translations = {
  title: 'Criando Formulário',
  title_edit: 'Editando Formulário',
  generalSectionTitle: 'Informações básicas',
  accessSectionTitle: 'Acesso',
  themeSectionTitle: 'Tema',
  themeLogo: 'Logo',
  themeColor: 'Cor',
  redirectionSection: 'Redirecionamento',
  redirectionLabel: 'Ao responder, redirecionar para execução',
  validationField: 'Campo de Validação',
  placeType: 'Tipo*',
  setupSection: 'Configurações de finalização',
  name: 'Nome*',
  checklist: 'Questionário*',
  description: 'Descrição*',
  access: 'Acesso*',
  private: 'Privado',
  public: 'Público',
  conclusionTitle: 'Título da mensagem de conclusão',
  conclusionBody: 'Corpo da mensagem de conclusão'
}

export default translations
